import React from 'react';
import { Col, Row, Button, FormGroup, Label } from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FormPhotoUpload } from '../../../../components/Common';
import { tenantSchema } from '../../../../models/tenant/tenantSchema';
import { tenantDefaults } from '../../../../models/tenant/tenantDefaults';

const CompanyForm = ({ initialData, onSave, isSaving }) => {
    // Mescla as informações iniciais com os padrões para evitar values undefined
    const formValues = { ...tenantDefaults, ...initialData };

    return (
        <Formik
            enableReinitialize
            initialValues={formValues}
            validationSchema={tenantSchema}
            onSubmit={(values, { setSubmitting }) => {
                onSave(values);
                setSubmitting(false);
            }}
        >
            {({ isSubmitting, setFieldValue, values }) => (
                <Form>
                    <div className="bg-white p-4 rounded-0 mb-4 border-top">
                        <h5 className="mb-4">Informações da Empresa</h5>
                        <Row className="mb-4 align-items-center">
                            <Col md="auto" className="text-center pe-4 border-end d-none d-md-block">
                                <FormPhotoUpload
                                    photoPreview={values.logoUrl}
                                    onChange={(base64Str) => setFieldValue('logoUrl', base64Str)}
                                    size="lg"
                                />
                                <div className="mt-3 text-muted" style={{ fontSize: '11px', fontWeight: '500' }}>LOGO DA EMPRESA</div>
                            </Col>
                            <Col className="ps-md-4">
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="tradeName">Nome Fantasia *</Label>
                                            <Field type="text" className="form-control rounded-0" name="tradeName" id="tradeName" placeholder="Ex: Academia Fit" />
                                            <ErrorMessage name="tradeName" component="div" className="text-danger mt-1 font-size-12" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="corporateName">Razão Social</Label>
                                            <Field type="text" className="form-control rounded-0" name="corporateName" id="corporateName" placeholder="Razão Social LTDA" />
                                            <ErrorMessage name="corporateName" component="div" className="text-danger mt-1 font-size-12" />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className="d-md-none mt-3">
                                    <Col className="text-center">
                                        <FormPhotoUpload
                                            photoPreview={values.logoUrl}
                                            onChange={(base64Str) => setFieldValue('logoUrl', base64Str)}
                                            size="xl"
                                        />
                                        <div className="mt-2 text-muted small fw-semibold">LOGO DA EMPRESA</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="document">CNPJ</Label>
                                    <Field type="text" className="form-control rounded-0" name="document" id="document" placeholder="00.000.000/0000-00" />
                                    <ErrorMessage name="document" component="div" className="text-danger mt-1 font-size-12" />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="email">E-mail Comercial</Label>
                                    <Field type="email" className="form-control rounded-0" name="email" id="email" placeholder="contato@empresa.com" />
                                    <ErrorMessage name="email" component="div" className="text-danger mt-1 font-size-12" />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="phone">Telefone / WhatsApp</Label>
                                    <Field type="text" className="form-control rounded-0" name="phone" id="phone" placeholder="(11) 90000-0000" />
                                    <ErrorMessage name="phone" component="div" className="text-danger mt-1 font-size-12" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="bg-white p-4 rounded-0 mt-4 border-top">
                        <h5 className="mb-4">Endereço</h5>
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="zipCode">CEP</Label>
                                    <Field type="text" className="form-control rounded-0" name="zipCode" id="zipCode" placeholder="00000-000" />
                                </FormGroup>
                            </Col>
                            <Col md={7}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="address">Logradouro</Label>
                                    <Field type="text" className="form-control rounded-0" name="address" id="address" placeholder="Rua / Avenida" />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="number">Número</Label>
                                    <Field type="text" className="form-control rounded-0" name="number" id="number" placeholder="123" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="complement">Complemento</Label>
                                    <Field type="text" className="form-control rounded-0" name="complement" id="complement" placeholder="Apto, Sala..." />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="neighborhood">Bairro</Label>
                                    <Field type="text" className="form-control rounded-0" name="neighborhood" id="neighborhood" />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="city">Cidade</Label>
                                    <Field type="text" className="form-control rounded-0" name="city" id="city" />
                                </FormGroup>
                            </Col>
                            <Col md={1}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="state">UF</Label>
                                    <Field type="text" className="form-control rounded-0" name="state" id="state" placeholder="SP" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="bg-white p-4 rounded-0 mt-4 border-top">
                        <h5 className="mb-4">Representante Legal (Contrato)</h5>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="legalRepresentative.name">Nome do Representante</Label>
                                    <Field type="text" className="form-control rounded-0" name="legalRepresentative.name" id="legalRepresentative.name" placeholder="Nome Completo" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="legalRepresentative.cpf">CPF</Label>
                                    <Field type="text" className="form-control rounded-0" name="legalRepresentative.cpf" id="legalRepresentative.cpf" placeholder="000.000.000-00" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="legalRepresentative.email">E-mail</Label>
                                    <Field type="email" className="form-control rounded-0" name="legalRepresentative.email" id="legalRepresentative.email" placeholder="rep@empresa.com" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="legalRepresentative.phone">Telefone</Label>
                                    <Field type="text" className="form-control rounded-0" name="legalRepresentative.phone" id="legalRepresentative.phone" placeholder="(11) 90000-0000" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex flex-wrap gap-2 justify-content-end mt-4">
                            <Button type="submit" color="primary" className="rounded-0 px-4" disabled={isSaving || isSubmitting}>
                                {isSaving ? (
                                    <>
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                                        Salvando...
                                    </>
                                ) : (
                                    "Salvar Alterações"
                                )}
                            </Button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default CompanyForm;
